<script setup>
import { ref } from "vue";

const isActive = ref("image");
</script>

<template>
  <div class="header-member-circle relative">
    <div
      class="header-member-circle-main relative h-full min-h-72 min-w-72 w-full aspect-square rounded-full overflow-hidden"
    >
      <div
        class="header-member-circle-main-image absolute h-full w-full object-cover transition-opacity"
        @click="isActive = 'quote'"
        :class="isActive === 'image' ? 'opacity-100' : 'opacity-0'"
      >
        <slot
          name="image"
        />
      </div>
      <div
        class="header-member-circle-main-quote absolute p-8 h-full w-full object-cover bg-secondary transition-opacity flex flex-col items-center justify-center"
        @click="isActive = 'image'"
        :class="isActive === 'quote' ? 'opacity-100' : 'opacity-0'"
      >
        <slot
          name="quote"
        />
      </div>
    </div>
    <div
      class="header-member-circle-small bg-secondary z-10 flex items-center justify-center h-16 w-16 absolute bottom-3 left-3 rounded-full overflow-hidden transition-opacity"
    >
      <button
        class="header-member-circle-main-image absolute transition-opacity"
        aria-label="click to show Image"
        @click="isActive = 'image'"
        :class="isActive === 'quote' ? 'opacity-100' : 'opacity-0'"
      >
        <slot
          name="smallimage"
        />
      </button>
      <button
        class="header-member-circle-main-quote absolute transition-opacity"
        aria-label="click to show Quote"
        @click="isActive = 'quote'"
        :class="isActive === 'image' ? 'opacity-100' : 'opacity-0'"
      >
        <AppIcon
          class="flex items-center justify-center h-full w-full"
          name="Quote"
        />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-member-circle-main {
  img {
    @apply w-full h-full object-cover;
  }
}
.header-member-circle-main-quote {
  :deep(p) {
    line-height: 1.1 !important;
    @apply first:text-base mt-0 first:mb-3 text-sm text-center;
  }
}
</style>
